"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

const SKIP_PREFIXES = ["/admin", "/api"];

/**
 * Records one first-party visit per browser session per UTC day.
 * Powers weekly unique visitors and visitor → signup on the admin beta gate.
 */
export function SiteVisitTracker() {
  const pathname = usePathname() || "/";

  useEffect(() => {
    if (SKIP_PREFIXES.some((p) => pathname.startsWith(p))) return;

    const day = new Date().toISOString().slice(0, 10);
    const key = "cl_visit_day";
    try {
      if (sessionStorage.getItem(key) === day) return;
    } catch {
      // Private mode can block sessionStorage; still send the beacon.
    }

    fetch("/api/analytics/visit", { method: "POST", credentials: "include" })
      .then(() => {
        try {
          sessionStorage.setItem(key, day);
        } catch {
          /* ignore */
        }
      })
      .catch(() => {});
  }, [pathname]);

  return null;
}
